export function UniversalCreateButtonSpotlight(_props: { dismiss: () => void }): null {
	return null;
}
